import React from "react";
import Navbar1 from "../../Elements/Navbar1/index.js";
import Footer from "../../Elements/Footer/index.js";
import { useNavigate } from "react-router-dom";
import "./style.css";
const PricingPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <Navbar1 />

      <div className="pricing-container">
        <h4 className="pricing-header">
          Flexible subscription plans to suit your needs - Individual to Enterprise
        </h4>

        <div className="pricing-cards">
          <div className="pricing-card">
            <h2>Individual Plan</h2>
            <h2 className="price" style={{ fontSize: 'smaller' }}>Starting at $15000/year</h2>
            <ul>
              <li>Designed for independent clinicians</li>
              <li>Patient onboarding and record digitization</li>
              <li>Access to oncology knowledge and decision-support tools</li>
              <li>Insights on diagnosis and treatment</li>
            </ul>
            <button
              className="btn-primary"
              onClick={() => navigate("/contact")}
            >
              Contact
            </button>
          </div>

          <div className="pricing-card">
            <h2>Team Plan</h2>
            <h2 className="price" style={{ fontSize: 'smaller' }}>Contact us for a custom quote</h2>
            <ul>
              <li>Best suited for small to medium-sized clinics</li>
              <li>Team collaboration tools for seamless communication</li>
              <li>Shared patient databases and workflow management</li>
              <li>Advanced patient engagement and diagnostic insights</li>
            </ul>
            <button
              className="btn-primary"
              onClick={() => navigate("/contact")}
            >
              Contact
            </button>
          </div>

          <div className="pricing-card">
            <h2>Enterprise Plan</h2>
            <h2 className="price" style={{ fontSize: 'smaller' }}>Contact us for a custom quote</h2>
            <ul>
              <li>Comprehensive solutions for hospitals and large healthcare organizations</li>
              <li>Enterprise-wide data integration and advanced analytics</li>
              <li>Compliance management and customizable reporting</li>
              <li>Priority customer support and training</li>
            </ul>
            <button
              className="btn-primary"
              onClick={() => navigate("/contact")}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PricingPage;
